import { createSlice } from '@reduxjs/toolkit';
import {
    aguaSalada,
} from '../actions/aguaSalada';


export const AguaSaladaReducer = createSlice({
    name: 'aguaSalada',
    initialState: {
        homeSort: {
            sortby: "_id",
            order: "desc",
            limit: 4,
            skip: 0
        },
        loading: false,
        sensores: [],
        current: null
    },
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            // GET ARTICLE
            .addCase(aguaSalada.pending, (state) => { state.loading = true })
            .addCase(aguaSalada.fulfilled, (state, action) => {
                state.loading = false;
                state.current = action.payload
            })
            .addCase(aguaSalada.rejected, (state) => { state.loading = false })
    }
})
export default AguaSaladaReducer.reducer;
